import { INITIAL_USER_STATE } from '../../utils/state';
import { UserActionType } from '../actionTypes/user';
import { PostDispatch, User, UserWithProfilePicture } from '../types';

interface UserState {
    user: User;
    users: Array<User>;
    usersWithActiveProjects: Array<string>;
    usersWithProfilePicture: Array<UserWithProfilePicture>;
}

const INITIAL_STATE: UserState = {
    user: INITIAL_USER_STATE,
    users: [],
    usersWithActiveProjects: [],
    usersWithProfilePicture: [],
};

const reducer = (state: UserState = INITIAL_STATE, action: PostDispatch) => {
    switch (action.type) {
        case UserActionType.GET_USER_BY_ID:
            return { ...state, user: action.payload as User };
        case UserActionType.GET_ALL_USERS:
        case UserActionType.GET_USERS_ROLE_USER:
            return { ...state, users: action.payload as Array<User> };
        case UserActionType.GET_USERS_WITH_ACTIVE_PROJECTS:
            return {
                ...state,
                usersWithActiveProjects: action.payload as Array<string>,
            };
        case UserActionType.GET_USERS_WITH_PROFILE_PICTURES:
            return {
                ...state,
                usersWithProfilePicture:
                    action.payload as Array<UserWithProfilePicture>,
            };
        case UserActionType.CREATE_USER:
            return {
                ...state,
                users: [...state.users, action.payload as User],
            };
        case UserActionType.DELETE_USER: // user will be marked and deleted after 24 hours,
        case UserActionType.UPDATE_USER:
            return {
                ...state,
                users: state.users.map((user: User) => {
                    const newUser = action.payload as User;
                    if (user._id === newUser._id) {
                        return newUser;
                    } else {
                        return user;
                    }
                }),
            };
        case UserActionType.UPDATE_MULTIPLE_USER:
            return {
                ...state,
                users: state.users.map((user: User) => {
                    const newUsers = action.payload as Array<User>;
                    return (
                        newUsers?.find((newUser) => newUser._id === user._id) ??
                        user
                    );
                }),
            };
        default:
            return state;
    }
};

export default reducer;
